import { LuBanknote } from 'react-icons/lu'
import { MdInsights } from 'react-icons/md'
import { MenuItem } from '../types'

const analyticsMenu: MenuItem[] = [
  {
    icon: MdInsights,
    name: 'Spend analytics',
    path: '/purchases?tab=analytics',
    code: 'spend-analytics',
  },
  {
    icon: LuBanknote,
    name: 'Income analytics',
    path: '/income?tab=analytics',
    code: 'income-analytics',
  },
]

export default analyticsMenu
